import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, message } from "antd";
import API from "../../../../../services/api-request";
import paymentImg from "../../../../../assets/image/ic_payment.png";
import SelectPeriode from "../../../../../components/SelectPeriode";
import { useNavigate } from "react-router";

const { Title, Text } = Typography;

const CardPayment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const [selectedPeriod, setSelectedPeriod] = useState("THIS_MONTH");

  const onSelectedPeriode = (value) => {
    setSelectedPeriod(value);
  };

  const getDataSummary = () => {
    setLoading(true);
    API.Post(`dashboard/summary`, {
      completeGroupBy: selectedPeriod,
    })
      .then((result) => {
        setLoading(false);

        setData(result?.data);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.info("Failed Fetch Summary");
      });
  };

  useEffect(() => {
    getDataSummary();
  }, [selectedPeriod]);

  return (
    <Card
      style={{
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: 8,
        cursor: "pointer",
      }}
      onClick={() => navigate("/transaction-client")}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <Text>Pembayaran Selesai</Text>
          <Title level={2}>{loading ? `0` : `${data?.data?.complete}`}</Title>
        </Col>
        <Col>
          <div
            style={{
              background: "#ffe58f",
              padding: 12,
              borderRadius: 8,
            }}
          >
            <img src={paymentImg} alt="Payment Completed" height={35} />
          </div>
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginTop: 8 }}>
        <Col></Col>
        <Col span={10}>
          <div onClick={(e) => e.stopPropagation()}>
            <SelectPeriode
              value={selectedPeriod}
              onChange={onSelectedPeriode}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardPayment;
